import { render, staticRenderFns } from "./lender-details.vue?vue&type=template&id=a55edff8&scoped=true"
import script from "./lender-details.vue?vue&type=script&lang=js"
export * from "./lender-details.vue?vue&type=script&lang=js"
import style0 from "./lender-details.vue?vue&type=style&index=0&id=a55edff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55edff8",
  null
  
)

export default component.exports